import * as React from 'react'

interface SubNavigationItemProps {
  children?: React.ReactNode
  isActive?: boolean
  onClick: () => void
  disabled?: boolean
  /** Zakładka z niepoprawnie wypełnionym formularzem - podświetlana na czerwono. */
  hasError?: boolean
}

export const SubNavigationButton = ({
  children,
  isActive,
  onClick,
  disabled = false,
  hasError = false,
}: SubNavigationItemProps) => {
  const stateClasses = hasError
    ? isActive
      ? 'tw-z-10 tw-border-b-[2px] tw-border-red-600 tw-text-red-600'
      : 'tw-border-b-[2px] tw-border-transparent tw-text-red-600 hover:tw-text-red-700'
    : isActive
      ? 'tw-z-10 tw-border-b-[2px] tw-border-blue-600 tw-text-blue-600'
      : 'tw-border-b-[2px] tw-border-transparent tw-text-content-base hover:tw-text-blue-600'

  return (
    <button
      disabled={disabled}
      onClick={() => onClick()}
      className={`tw-z-10 tw-text-nowrap tw-p-4 tw-text-sm tw-font-medium hover:tw-no-underline ${
        disabled ? 'tw-opacity-20' : ''
      } ${stateClasses}`}
    >
      {children}
    </button>
  )
}
